import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import Form from "@common/externos/components/validation/form.validation";
import decaActions from "../store/deca.actions";
import decaSelector from "../store/deca.selectors";
import documentoSelector from "../components/documentos/store/documento.selectors";
import autoBind from "react-autobind";

//Subforms
import Solicitacao from "../components/solicitacao/container/solicitacao.subform";
import DadosSolicitante from "../components/dadosSolicitante/container/dadosSolicitante.subform";
import EnderecoPrincipal from "../components/enderecoPrincipal/container/enderecoprincipal.subform";
import EnderecoCobranca from "../components/enderecoCobranca/container/enderecocobranca.subform";
import Socio from "../components/socio/container/socio.subform";
import Cnae from "../components/cnae/container/cnae.subform";
import Atividades from "../components/atividades/container/atividades.subform";
import Documentos from "../components/documentos/container/documentos.subform";
import Historicos from "../components/historico/container/historicos.subform";

import solicitacaoSelector from "../../deca/components/solicitacao/store/solicitacao.selectors";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    this.props.decaActions.getParametro();
    this.props.decaActions.loadComboGrupo();
  }

  get initialValues() {
    return {
      CpfCnpj: undefined,
      TipoSolicitacao: undefined,
    };
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "DECA" });
  }

  render() {
    const { onSubmit, onCancel, prefix, retificar } = this.props;

    const { anexo, anexoCustomizado } = this.props.documentoSelector.documento;
    const { solicitacao } = this.props.solicitacaoSelector;
    const { disableAllSolicitacao } = this.props.decaSelector.deca;

    let habilitaSolicitacao = false;
    if (
      solicitacao.TipoSolicitacao == "" ||
      solicitacao.TipoSolicitacao == undefined
    ) {
      habilitaSolicitacao = false;
    } else {
      if (solicitacao.TipoSolicitacao == "1") {
        habilitaSolicitacao = true;
      } else if (solicitacao.TipoSolicitacao == "2") {
        if (solicitacao.CCM != undefined) {
          habilitaSolicitacao = true;
        }
      } else if (
        solicitacao.Ccm == "" ||
        solicitacao.Ccm == undefined ||
        solicitacao.TipoSolicitacao == "3"
      ) {
        habilitaSolicitacao = false;
      } else {
        habilitaSolicitacao = true;
      }
    }

    let contemAnexo = anexo?.length > 0;
    let contemAnexoCustomizado = anexoCustomizado?.length > 0;

    return (
      <Form
        onSubmit={onSubmit}
        onCancel={onCancel || this.onCancel}
        initialValues={this.initialValues}
      >
        {(form) => (
          <Fragment>
            <Solicitacao
              form={form}
              habilitaSolicitacao={solicitacao.disableTipoSolicitacao}
              disableAll={
                habilitaSolicitacao ? solicitacao.tipoSolicitacaoDisabled : true
              }
              prefix={"I"}
              disableAllDadosCadastrais={
                retificar ? false : !habilitaSolicitacao
              }
            />
            <EnderecoPrincipal form={form} />
            <EnderecoCobranca form={form} />
            <Socio
              form={form}
              isView={false}
              disableAll={
                disableAllSolicitacao ||
                (retificar
                  ? false
                  : habilitaSolicitacao
                  ? solicitacao.tipoSolicitacaoDisabled
                  : true)
              }
            />
            <Cnae
              form={form.values.Cnae}
              disableAll={
                disableAllSolicitacao ||
                (retificar
                  ? false
                  : habilitaSolicitacao
                  ? solicitacao.tipoSolicitacaoDisabled
                  : true)
              }
            />
            <Atividades
              form={form.values.SuggestionAtividade}
              disableAll={
                disableAllSolicitacao ||
                (retificar
                  ? false
                  : habilitaSolicitacao
                  ? solicitacao.tipoSolicitacaoDisabled
                  : true)
              }
            />
            {(contemAnexo || contemAnexoCustomizado) && (
              <Documentos form={form} prefix={"I"} />
            )}
            <DadosSolicitante form={form} />
            <Historicos
              form={form}
              disableAll={
                disableAllSolicitacao || solicitacao.disableTipoSolicitacao
              }
            />
          </Fragment>
        )}
      </Form>
    );
  }
}

export default connect({
  actions: {
    decaActions,
  },
  selectors: {
    documentoSelector,
    solicitacaoSelector,
    decaSelector,
  },
})(Container);
